import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { AmazonService } from "../../services/amazon.service";
import { WizardComponent } from "ngx-wizard";
import * as ps from "perfect-scrollbar";
import "jquery";
declare var $: any;
import 'slick-carousel';
import { Cookie } from "ng2-cookies/ng2-cookies";
import { ResponseError } from "../../objects/common/responseError";
import { Seller } from "../../objects/amazon/seller";
import { ConfigService } from "../../services/configService";
import { UserService } from "../../services/userService";
import { Router } from "@angular/router";
import { NavigateHelper } from "../../common/helpers/navigateHelper";


@Component({
    selector: 'amazon',
    templateUrl: 'amazon-empty-page.component.html',
    styleUrls : ["../../../node_modules/slick-carousel/slick/slick.css",
                "../../../node_modules/slick-carousel/slick/slick-theme.css"],
    moduleId: module.id.toString(),
    encapsulation : ViewEncapsulation.None
})
export class AmazonComponent implements AfterViewInit, OnInit {
    @ViewChild(WizardComponent) wizardComponent: WizardComponent;

    @ViewChild('wizardFooterTemplate')
    public wizardFooterTemplate: TemplateRef<any>;


    @ViewChild('amazonPanel') amazonPanel: ElementRef;

    public sellerId: string;
    public marketplaceId: string;
    public mwsAuthToken: string;
    public company: string;
    public showInfo: boolean = true;
    private accessToken: string;
    public currentSeller: Seller;


    public errors: ResponseError[] = [];


    public constructor(private renderer: Renderer2, private amazonService: AmazonService,  private configService: ConfigService, private userService: UserService, private router: Router) {
    }

    public ngOnInit(){
        let hash = location.hash;

        if (String.isNullOrEmpty(hash)){
            this.login();
            return;
        }


        if (!location.hash.split('access_token='))
            return;

        this.accessToken = location.hash.match(/access_token=([^&]*)&/)[1];

        if (!this.accessToken)
            return;


        this.userService.getExternalUserInfo(this.accessToken).then(resp => {
            Cookie.set(this.configService.config.ApiTokenCookieName, this.accessToken, 1, '/');
            Cookie.set(this.configService.config.UserAmazonCookieName, resp.Data.Id.toString(), 1, '/');
            const userId = resp.Data.Id;
            this.showInfo = false;
            this.getAmazonUser(userId).then( resp =>{
                this.router.navigate([`amazon/info/dashboard`]);

                if (!resp){
                    this.router.navigate(["amazon/info/seller"]);
                }
            });

        });


    }

    public login(): void {
        this.showInfo = false;
        Cookie.delete(this.configService.config.ApiTokenCookieName);
        Cookie.delete(this.configService.config.UserAmazonCookieName);
        Cookie.delete(this.configService.config.UserCookieName);

        this.userService.prepareExternalLogin().then(x => {
            window.location.href =
                `${this.configService.config.AmazonApiUrl}/api/Account/ExternalLogin?provider=Amazon&response_type=token&client_id=self&redirect_uri=${this.configService.config.AmazonApiUrl}/api/Account/ExternalLogin&state=0eYM9Qg6Gu3Z8H3CqEQUfmI3i_XM59C-q5UUdAONOpw1`;
        });
    }

    public getAmazonUser(id: number): Promise<Seller>{
        return this.amazonService.getSellerByUserId(id).then( resp =>{
            return this.currentSeller = resp.Data;
        })
    }

    public ngAfterViewInit(): void {
        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");

        if(window.navigator.userAgent.indexOf("Edge") > -1)
            return;

        ps.initialize(this.amazonPanel.nativeElement);
    }

    public isValid(): boolean {
        return !String.isNullOrEmpty(this.sellerId) &&
            !String.isNullOrEmpty(this.marketplaceId) &&
            !String.isNullOrEmpty(this.mwsAuthToken);
    }

    public exportProducts(): void {
        if (!this.isValid())
            return;

        this.amazonService.exportProducts(this.sellerId, this.marketplaceId, this.mwsAuthToken, this.company);
    }

    public goToOtherSite(): void {
        window.location.href = "https://borderbuddy.com/contact/"//TODO ask Yuriy for URL
    }

    public scrollTop(): void {
        if (this.amazonPanel)
            this.amazonPanel.nativeElement.scrollTop = 0;

    }

    public carouselTabSelect(){
        this.scrollTop();
        $(".slick-my").slick({
            arrows: false,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
        })
    }
}


// WEBPACK FOOTER //
// ./app/components/amazon/amazon.component.ts